import { NgIf } from '@angular/common';
import { NgModule } from '@angular/core';

import { FeatureGuardModule } from '@recruitee/feature-guard';
import {
  BadgeComponent,
  DropdownHeaderComponent,
  DropdownItemComponent,
  FormFieldComponent,
  HeadingComponent,
  IconButtonComponent,
  IconComponent,
  InputComponent,
} from '@recruitee/user-interface';

import { RedactorInsertsDropdownHeaderComponent } from './redactor-inserts-button/redactor-inserts-dropdown-header/redactor-inserts-dropdown-header.component';
import { RedactorInsertsDropdownItemComponent } from './redactor-inserts-button/redactor-inserts-dropdown-item/redactor-inserts-dropdown-item.component';

@NgModule({
  imports: [
    BadgeComponent,
    DropdownHeaderComponent,
    DropdownItemComponent,
    FeatureGuardModule,
    FormFieldComponent,
    HeadingComponent,
    IconButtonComponent,
    IconComponent,
    InputComponent,
    NgIf,
  ],
  declarations: [RedactorInsertsDropdownHeaderComponent, RedactorInsertsDropdownItemComponent],
  exports: [RedactorInsertsDropdownHeaderComponent, RedactorInsertsDropdownItemComponent],
})
export class RedactorInsertsItemModule {}
